import { request, combineUrl, localConfig, getCurrentLang, getProfileToken } from '~/common';

const commonRequest = (params, callback, action, options) => {
    return request(combineUrl(localConfig.obtApiUrl, `Common/V1/json/${action}`), params, callback, options);
}

const _cityCache = {};
const _cityQueue = {};
export function searchCity(query, options, callback) {
    const { countryCode } = options || {};
    let url = combineUrl(localConfig.obtApiUrl, `Common/City.ashx?q=${encodeURIComponent(query || '')}&lang=all&includeCountry=1&countryCode=${countryCode || ''}&profileToken=${encodeURIComponent(getProfileToken())}`);
    if (_cityCache[url]) {
        return new Promise(resolve => {
            typeof callback == 'function' && callback(null, _cityCache[url]);
            resolve(_cityCache[url]);
        });
    }
    if (_cityQueue[url]) {
        _cityQueue[url].push(callback);
        return;
    }
    _cityQueue[url] = [];
    return request(url, null, null, { needValidAccessToken: false }).then((rs) => {
        if (rs && rs.datas) {
            _cityCache[url] = rs;
        }
        typeof callback == 'function' && callback(null, rs);
        while (_cityQueue[url].length) {
            const cb = _cityQueue[url].shift();
            typeof cb == 'function' && cb(null, rs);
        }
        delete _cityQueue[url];
        return rs;
    });
}

export function exceptionLog(params, callback) {
    return commonRequest(params, callback, 'ExceptionLog', { needValidAccessToken: false });
}

export function getRiskNews(params, callback) {
    return commonRequest(params, callback, 'GetRiskNews');
}

export function getRiskCountries(params, callback) {
    return commonRequest(params, callback, 'GetRiskCountries');
}

export function getRiskCountryAlert(params, callback) {
    return commonRequest(params, callback, 'GetRiskCountryAlert');
}

export function getContent4CTMPortal(params, callback) {
    return commonRequest(params, callback, 'GetContent4CTMPortal', { needValidAccessToken: false });
}

export function searchHotelCity(query, country, callback) {
    let url = combineUrl(localConfig.obtApiUrl, `Hotel/Location.ashx?type=City&q=${encodeURIComponent(query || '')}&lang=${getCurrentLang()}&country=${country || ''}`);
    return request(url, null, callback, { needValidAccessToken: false });
}

export function searchHotel(query, city, callback) {
    let url = combineUrl(localConfig.obtApiUrl, `Hotel/Location.ashx?type=Hotel&q=${encodeURIComponent(query || '')}&lang=${getCurrentLang()}&city=${city || ''}`);
    return request(url, null, callback, { needValidAccessToken: false });
}

export function searchAirline(query, callback) {
    let url = combineUrl(localConfig.obtApiUrl, `Common/Airline.ashx?q=${encodeURIComponent(query || '')}&lang=${getCurrentLang()}&qty=5`);
    return request(url, null, callback, { needValidAccessToken: false });
}

export function searchCountry(query, callback) {
    let url = combineUrl(localConfig.obtApiUrl, `Common/Country.ashx?q=${encodeURIComponent(query || '')}&lang=${getCurrentLang()}&qty=5&profileToken=${encodeURIComponent(getProfileToken())}`);
    return request(url, null, callback, { needValidAccessToken: false });
}

export function getFooterScript4CTMPortal(params, callback) {
    return commonRequest(params, callback, 'GetFooterScript4CTMPortal');
}

export function getContextByKey(params, callback) {
    return commonRequest(params, callback, 'getcontextbykey', { needValidAccessToken: false });
}

export function getConfig(params, callback) {
    return commonRequest(params, callback, 'GetConfig', { needValidAccessToken: false });
}

export function getCtmMobileDownload(params, callback) {
    return commonRequest(params, callback, 'getCtmMobileDownload');
}

export function getCaptcha(params, callback) {
    return commonRequest(params, callback, 'getCaptcha', { needValidAccessToken: false });
}

export function getGenericContent(params, callback) {
    return commonRequest(params, callback, 'GetGenericContent');
}